module.exports = __webpack_public_path__ + "images/deliverect-icon.2acd860dcfb1d6ae5906317ca3332b03.svg";